import React from 'react';
import { Link } from 'gatsby';

export const BackButton = () => {
  return (
    <div className="mt-12 px-2 text-2xl md:text-4xl font-bold text-center">
      <Link to="/" className="py-4 rounded-lg border-2 border-solid w-1/2 sm:w-1/2 mx-auto flex justify-center items-center hover:opacity-75" style={{borderColor: 'rgb(222, 242, 217)'}}>back</Link>
    </div>
  );
};